module.exports = __webpack_public_path__ + "img/redux-logo.5487a296.png";